var _excluded = ["domRef", "className", "children", "placement", "autoAlign", "autoFocusSearch", "placeholder", "showAll", "rimless", "invalid", "searchable", "alignType", "useTag", "width", "show", "onShow", "onHide", "emptyRender", "emptyContent", "style", "selectedItemRemovable", "renderTrigger", "popoverWidth", "popoverClassName", "popoverWrapperClassName", "popoverPreventOverflow", "boundariesDetectionDebounce", "onSearchChange", "renderSelected", "multipleRenderSelected", "renderPlaceholder", "searchPlaceholder", "getPopupContainer", "selectedOptions", "filled", "prefix", "renderFooter", "renderIcon", "onVisibleChange", "collapse"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import { combineClasses } from '@okee-uikit/react-utils';
import { useDirection, useLocale, usePrefixCls } from '@okee-uikit/react-config';
import { RcPopper } from '../../../hooks/popper';
import { useSelect } from '../../../hooks/select';
import { SelectAll } from './SelectAll';
import { SelectPopper } from './SelectPopper';
import { SelectMultiplePopper } from './SelectMultiplePopper';
import { SelectRimlessPopper } from './SelectRimlessPopper';
export function SelectBase(props) {
  var locale = useLocale('select.placeholder');

  var domRef = props.domRef,
      className = props.className,
      children = props.children,
      _props$placement = props.placement,
      placement = _props$placement === void 0 ? 'bottom-start' : _props$placement,
      _props$autoAlign = props.autoAlign,
      autoAlign = _props$autoAlign === void 0 ? true : _props$autoAlign,
      _props$autoFocusSearc = props.autoFocusSearch,
      autoFocusSearch = _props$autoFocusSearc === void 0 ? false : _props$autoFocusSearc,
      _props$placeholder = props.placeholder,
      placeholder = _props$placeholder === void 0 ? locale : _props$placeholder,
      _props$showAll = props.showAll,
      showAll = _props$showAll === void 0 ? false : _props$showAll,
      _props$rimless = props.rimless,
      rimless = _props$rimless === void 0 ? false : _props$rimless,
      _props$invalid = props.invalid,
      invalid = _props$invalid === void 0 ? false : _props$invalid,
      searchable = props.searchable,
      alignType = props.alignType,
      useTag = props.useTag,
      width = props.width,
      show = props.show,
      onShow = props.onShow,
      onHide = props.onHide,
      emptyRender = props.emptyRender,
      emptyContent = props.emptyContent,
      style = props.style,
      selectedItemRemovable = props.selectedItemRemovable,
      renderTrigger = props.renderTrigger,
      popoverWidth = props.popoverWidth,
      popoverClassName = props.popoverClassName,
      popoverWrapperClassName = props.popoverWrapperClassName,
      popoverPreventOverflow = props.popoverPreventOverflow,
      boundariesDetectionDebounce = props.boundariesDetectionDebounce,
      onSearchChange = props.onSearchChange,
      renderSelected = props.renderSelected,
      multipleRenderSelected = props.multipleRenderSelected,
      renderPlaceholder = props.renderPlaceholder,
      searchPlaceholder = props.searchPlaceholder,
      getPopupContainer = props.getPopupContainer,
      selectedOptions = props.selectedOptions,
      _props$filled = props.filled,
      filled = _props$filled === void 0 ? false : _props$filled,
      prefix = props.prefix,
      renderFooter = props.renderFooter,
      renderIcon = props.renderIcon,
      onVisibleChange = props.onVisibleChange,
      _props$collapse = props.collapse,
      collapse = _props$collapse === void 0 ? true : _props$collapse,
      extra = _objectWithoutProperties(props, _excluded);

  var select = useSelect();
  var multiple = select.multiple;
  var extraProps = select.getExtraProps();
  var size = extraProps.size || 'md';
  var clearable = extraProps.clearable;
  var direction = useDirection();
  var classes = combineClasses(usePrefixCls('select', {
    size: size,
    single: true,
    render: Boolean(multipleRenderSelected),
    multiple: multiple,
    uncollapse: !collapse,
    focus: show,
    rtl: direction === 'rtl'
  }), usePrefixCls('can-input-grouped', {
    focus: show
  }), className);
  var childNode = typeof children === 'function' ? children(props) : children;

  var renderPopper = function renderPopper() {
    if (rimless) {
      return React.createElement(SelectRimlessPopper, {
        useTag: useTag,
        show: show,
        clearable: clearable,
        placement: placement,
        placeholder: placeholder,
        size: size,
        onShow: onShow,
        onHide: onHide,
        searchable: searchable,
        alignType: alignType,
        width: width,
        emptyRender: emptyRender,
        emptyContent: emptyContent,
        renderTrigger: renderTrigger,
        popoverWidth: popoverWidth,
        popoverClassName: popoverClassName,
        popoverWrapperClassName: popoverWrapperClassName,
        onSearchChange: onSearchChange,
        searchPlaceholder: searchPlaceholder,
        boundariesDetectionDebounce: boundariesDetectionDebounce,
        getPopupContainer: getPopupContainer,
        renderFooter: renderFooter,
        onVisibleChange: onVisibleChange
      }, React.createElement(SelectAll, {
        showAll: showAll
      }), childNode);
    }

    if (select.multiple) {
      return React.createElement(SelectMultiplePopper, {
        show: show,
        invalid: invalid,
        placement: placement,
        placeholder: placeholder,
        autoAlign: autoAlign,
        autoFocusSearch: autoFocusSearch,
        size: size,
        onShow: onShow,
        onHide: onHide,
        searchable: searchable,
        emptyRender: emptyRender,
        emptyContent: emptyContent,
        multipleRenderSelected: multipleRenderSelected,
        selectedOptions: selectedOptions,
        searchPlaceholder: searchPlaceholder,
        popoverWidth: popoverWidth,
        selectedItemRemovable: selectedItemRemovable,
        popoverClassName: popoverClassName,
        popoverWrapperClassName: popoverWrapperClassName,
        onSearchChange: onSearchChange,
        boundariesDetectionDebounce: boundariesDetectionDebounce,
        getPopupContainer: getPopupContainer,
        filled: filled,
        prefix: prefix,
        renderFooter: renderFooter,
        onVisibleChange: onVisibleChange,
        collapse: collapse
      }, React.createElement(SelectAll, {
        showAll: showAll
      }), childNode);
    }

    return React.createElement(SelectPopper, {
      show: show,
      invalid: invalid,
      placement: placement,
      placeholder: placeholder,
      autoAlign: autoAlign,
      autoFocusSearch: autoFocusSearch,
      size: size,
      onShow: onShow,
      onHide: onHide,
      searchable: searchable,
      renderSelected: renderSelected,
      renderPlaceholder: renderPlaceholder,
      emptyRender: emptyRender,
      emptyContent: emptyContent,
      popoverWidth: popoverWidth,
      popoverClassName: popoverClassName,
      popoverWrapperClassName: popoverWrapperClassName,
      popoverPreventOverflow: popoverPreventOverflow,
      boundariesDetectionDebounce: boundariesDetectionDebounce,
      onSearchChange: onSearchChange,
      searchPlaceholder: searchPlaceholder,
      getPopupContainer: getPopupContainer,
      filled: filled,
      prefix: prefix,
      renderFooter: renderFooter,
      renderIcon: renderIcon,
      onVisibleChange: onVisibleChange
    }, childNode);
  };

  return React.createElement("span", _objectSpread(_objectSpread({}, extra), {}, {
    ref: domRef,
    className: classes,
    style: _objectSpread(_objectSpread({}, style), {}, {
      width: width !== null && width !== void 0 ? width : style === null || style === void 0 ? void 0 : style.width
    })
  }), React.createElement(RcPopper, null, renderPopper()));
}